<main>
  <div class="container main-panel">
    <app-header-ad [position]="'top'"></app-header-ad>
    <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
    <article *ngIf="content" class="article-content">
      <div *ngIf="content.CompletedPurchase" class="row">
        <div class="col-sm-12">
          <h4>You have successfully purchased the digital badge !</h4>
          <hr />
        </div>
      </div>
      <div class="row article-row">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <div class="row">
            <div class="col-sm-12 col-md-3 col-lg-3 margin-top-10 text-center"></div>
            <div *ngIf="content && content.digitalBadgePublishedDisplayModel"
              class="col-sm-12 col-md-6 col-lg-6 text-center comments-wrap">
              <h1>{{ content.digitalBadgePublishedDisplayModel.Title }}</h1>
            </div>
            <div *ngIf="showPassedExam()" class="col-sm-12 col-md-3 col-lg-3 text-center margin-top-10">
              <div style="align-self:baseline">
                <h4>
                  You have earned this badge.
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div id="digitalBadgeArea" class="col-sm-12 col-md-12 col-lg-12">
            <div *ngIf="content && content.digitalBadgePublishedDisplayModel && content.digitalBadgePublishedDisplayModel.DigitalBadgeCourse &&
                content.digitalBadgePublishedDisplayModel.DigitalBadgeCourse.VideoID" class="row embedded-video">
              <div [innerHtml]="theVideoUrl"></div>
            </div>
            <br />
            <app-social-media></app-social-media>

            <br />

            <div class="row">
              <div class="col-sm-12 col-md-3 col-lg-3">&nbsp;</div>
              <div class="col-sm-12 col-md-3 col-lg-3">
                <button id="overviewBtn" class="btn btn-block selected-digital-badge-overview-buttons" onclick="{
                                            document.getElementById('faqsAll').setAttribute('style', 'display: none'); 
                                            document.getElementById('overviewAll').setAttribute('style', 'display: inline');
                                            document.getElementById('faqsBtn').setAttribute('style', 'color: white !important; font-weight: normal !important'); 
                                            document.getElementById('overviewBtn').setAttribute('style', 'color: black !important; font-weight: bold');
                                        }">
                  Course overview</button><br />
              </div>
              <div class="col-sm-12 col-md-3 col-lg-3">
                <button id="faqsBtn" class="btn btn-block digital-badge-overview-buttons" onclick="{
                                        document.getElementById('faqsAll').setAttribute('style', 'display: inline'); 
                                        document.getElementById('overviewAll').setAttribute('style', 'display: none');
                                        document.getElementById('faqsBtn').setAttribute('style', 'color: black !important; font-weight: bold !important'); 
                                        document.getElementById('overviewBtn').setAttribute('style', 'color: white !important; font-weight: normal');
                                }">
                  {{
                    faqsTitle
                  }}</button><br />
              </div>
            </div>

            <br />
            <span id="overviewAll">
              <div class="row">
                <div class="helpitemdescription col-sm-12 col-md-12 col-lg-12">
                  <span [innerHTML]="getOverviewHtmlPart1()"></span>
                </div>
              </div>
              <div class="row">
                <div class="helpitemdescription col-sm-12 col-md-12 col-lg-12" id="overviewPart2" style="display: none">
                  <span [innerHTML]="getOverviewHtmlPart2()"></span>
                </div>
              </div>
            </span>
            <span id="faqsAll" style="display: none">
              <div class="row">
                <div class="helpitemdescription col-sm-12 col-md-12 col-lg-12">
                  <span [innerHTML]="getFaqsHtmlPart1()"></span>
                </div>
              </div>
              <div class="row">
                <div class="helpitemdescription col-sm-12 col-md-12 col-lg-12" id="faqsPart2" style="display: none">
                  <span [innerHTML]="getFaqsHtmlPart2()"></span>
                </div>
              </div>
            </span>

            <div class="row">
              <div class="col-sm-12 col-md-12 col-lg-12 margin-top-10 margin-bottom-20 showmore" onclick="{
                                        if (document.getElementById('showMoreText').textContent === 'Show More')
                                        {
                                            document.getElementById('showMoreText').textContent = 'Show Less';
                                            document.getElementById('overviewPart2').setAttribute('style', 'display: inline'); 
                                            document.getElementById('faqsPart2').setAttribute('style', 'display: inline');
                                        } else{
                                            document.getElementById('showMoreText').textContent = 'Show More';
                                            document.getElementById('overviewPart2').setAttribute('style', 'display: none'); 
                                            document.getElementById('faqsPart2').setAttribute('style', 'display: none');
                                        }

                                }">
                <a id="showMoreText">Show More</a>
              </div>
            </div>
            <hr class="solid-line margin-top-10 margin-bottom-10" />

            <p></p>
            <div style=""></div>
          </div>
        </div>
        <div *ngIf="content && content.digitalBadgePublishedDisplayModel" class="row" style="width: 100% !important">
          <div id="digitalBadgeModulesArea" class="col-sm-12 col-md-12 col-lg-12">
            <span *ngFor="
                let aEntry of content.digitalBadgePublishedDisplayModel.Entries
              ">
              <hr />
              <div class="row margin-top-10">
                <div class="col-sm-2 col-md-1 col-lg-1 text-left margin-top-5">
                  <span *ngIf="aEntry.ThumbnailImageAssetID">
                    <a [routerLink]="[
                        '/videocoursesmoduleview',
                        aEntry.Information.Alias
                      ]">
                      <img loading="lazy" [src]="getEntryImageUrl(aEntry.ThumbnailFilename)" alt="Image"
                        style="max-height: 48px; max-width: 48px" />
                    </a>
                  </span>
                </div>
                <div *ngIf="aEntry && aEntry.Information" class="col-sm-10 col-md-10 col-lg-4 text-left margin-top-5">
                  <h4 class="digital-badge-header">
                    {{ aEntry.Information.Title }}
                  </h4>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-6 margin-top-5">
                  <a class="btn btn-block digital-badge-help-buttons" [routerLink]="[
                      '/videocoursesmoduleview',
                      aEntry.Information.Alias
                    ]">
                    Watch video</a>
                </div>
                <!--
                <div class="col-sm-12 col-md-12 col-lg-3 margin-top-5">
                  <a class="btn btn-block digital-badge-help-buttons" [routerLink]="[
                      '/videocoursesmoduleexamview',
                      aEntry.Information.Alias
                    ]">
                    Self-test questions</a>
                </div>
                -->
              </div>
            </span>
            <hr class="solid-line margin-top-10 margin-bottom-10" />

            <div id="digitalBadgeTakeExamArea" class="row margin-top-10">
              <div class="col-sm-12 col-md-5 col-lg-5 margin-top-10 digital-badge-description">
                <strong id="hoverhighlight" class="digital-badge-description-strong">Final Exam</strong>
                only needs to be taken by those seeking to earn the
                <a target="_blank" class="video-course-exam-explain" [routerLink]="['/explainerview']">Digital Badge</a>
                credentials for this course.
              </div>
              <div *ngIf="isLoggedIn() && !showPassedExam() && content && content.digitalBadgePublishedDisplayModel"
                class="col-sm-12 col-md-6 col-lg-6 margin-top-10">
                <button (click)="
                    showFinal(
                      content.digitalBadgePublishedDisplayModel
                        .DigitalBadgeCourse.Information.Alias
                    )
                  " value="Take the Final Exam" class="btn digital-badge-test-buttons btn-primary">
                  Take the Final Exam
                </button>
              </div>
              <div *ngIf="!isLoggedIn()" class="col-sm-12 col-md-6 col-lg-6 margin-top-10">
                <a [routerLink]="['/loginview']" value="Take the Final Exam"
                  class="btn digital-badge-test-buttons btn-primary">Take the Final Exam
                  <span style="font-size: 12px; padding-bottom: 2px">(You need to log in first)</span></a>
              </div>
            </div>

          </div>
        </div>
      </div>
    </article>
    <div></div>
    <div class="row margin-top-20" style="display: inline">
      <app-header-ad [position]="'bottom'"></app-header-ad>
    </div>
  </div>
</main>